import { GGNLocations } from "../../interfaces/intakes.reports"
import { AccordionCard } from "../cards/AccordionCard"
import { HiOutlineTrash } from "react-icons/hi2";
import DatePicker from 'react-datepicker';
import { useState } from "react";

interface Props {
    location: GGNLocations
    handleLocationValue: (location: GGNLocations) => void
}
export const GGNLocation = ({ location, handleLocationValue }: Props) => {

    const [coords, setCoords] = useState<{ lat: string, lon: string }>({ lat: "", lon: "" })

    const handleSingleValue = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const updatedLocation = { ...location };

        if (name === 'ggn_number') {
            updatedLocation.ggn_number = value;
        } else if (name === 'city') {
            updatedLocation.city = value;
        } else if (name === 'country') {
            updatedLocation.country = value;
        } else if (name === 'quantity') {
            updatedLocation.quantity = Number(value);
        }

        handleLocationValue(updatedLocation);
    }

    const handleDate = (date: Date) => {
        const updatedLocation = { ...location };
        updatedLocation.harvest_day = date;
        handleLocationValue(updatedLocation);
    };

    const handleCoordsInput = (idx: "lat" | "lon", value: string) => {
        const next = { ...coords };
        next[idx] = value;
        setCoords(next);
    };

    const handleCoords = () => {
        const lat = Number(coords.lat);
        const lon = Number(coords.lon);

        if (Number.isNaN(lat) || Number.isNaN(lon)) return;

        const updatedLocation: GGNLocations = {
            ...location,
            coords: { lat, lon },
        };

        handleLocationValue(updatedLocation);
    };

    return (

        <div className="tw-py-4">
            <div className="tw-grid tw-grid-cols-3 tw-gap-2">
                <div>
                    <p className="tw-text-gray-500 tw-text-[.75rem]">Harvest day</p>
                    <DatePicker
                        className="date-edit tw-flex tw-w-full tw-h-10"
                        dateFormat="dd / MM / yyyy"
                        selected={location.harvest_day}
                        onChange={(date: Date) => handleDate(date)}
                        placeholderText="Select a date"
                        maxDate={new Date()}
                    />
                </div>

                <div>
                    <p className="tw-text-gray-500 tw-text-[.75rem]">GGN Number</p>
                    <input
                        type="text"
                        name='ggn_number'
                        className='mb-1 tw-w-full tw-h-10'
                        placeholder="GGN Number"
                        value={location.ggn_number}
                        onChange={(e) => handleSingleValue(e)}
                    />
                </div>

                <div>
                    <p className="tw-text-gray-500 tw-text-[.75rem]">City</p>
                    <input
                        type="text"
                        name='city'
                        className='mb-1 tw-w-full tw-h-10'
                        placeholder="City"
                        value={location.city}
                        onChange={(e) => handleSingleValue(e)}
                    />
                </div>

            </div>
            <div className="tw-grid tw-grid-cols-3 tw-gap-2">
                <div>
                    <p className="tw-text-gray-500 tw-text-[.75rem]">Country</p>
                    <input
                        type="text"
                        name='country'
                        className='mb-1 tw-w-full tw-h-10'
                        placeholder="Country"
                        value={location.country}
                        onChange={(e) => handleSingleValue(e)}
                    />
                </div>
                {/* <div>
                    <p className="tw-text-gray-500 tw-text-[.75rem]">Quantity</p>
                    <input
                        type="number"
                        name="quantity"
                        className='mb-1 tw-w-full tw-h-10'
                        placeholder="Quantity"
                        value={location.quantity ? location.quantity : 0}
                        onChange={(e) => handleSingleValue(e)}
                    />
                </div> */}


                <div>
                    <p className="tw-text-gray-500 tw-text-[.75rem]">Latitude</p>
                    <input
                        type="number"
                        step="any"
                        className="tw-w-full tw-h-10"
                        value={coords.lat}
                        onChange={e => handleCoordsInput("lat", e.target.value)}
                        onFocus={e => e.target.select()}
                        onBlur={handleCoords}
                    />
                </div>

                <div>
                    <p className="tw-text-gray-500 tw-text-[.75rem]">Longitude</p>
                    <input
                        type="number"
                        step="any"
                        className="tw-w-full tw-h-10"
                        value={coords.lon}
                        onChange={e => handleCoordsInput("lon", e.target.value)}
                        onFocus={e => e.target.select()}
                        onBlur={handleCoords}

                    />
                </div>





            </div>
        </div>
    )
}
